import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-email-inativar-modal',
  templateUrl: './email-inativar-modal.component.html',
  styleUrls: ['./email-inativar-modal.component.scss'],
})
export class EmailInativarModalComponent implements OnInit {
  @Input() email: string = '';

  justificativaForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit(): void {
    this.justificativaForm = this.fb.group({
      justificativa: ['', [Validators.required, Validators.maxLength(500)]],
    });
  }

  handleOk(): void {
    if (this.justificativaForm.invalid) {
      this.justificativaForm.markAllAsTouched();
      return;
    }

    this.modalRef.close(this.justificativaForm.get('justificativa')?.value);
  }

  handleCancel(): void {
    this.modalRef.close();
  }
}
